export const getReorderChatId = (vendorId: string, styleColor: string) =>
  `${vendorId}_${styleColor.replace(/\//g, '--')}`;
